import React from 'react'

const VehicleBadge = ({icon, value}) => {
    return (
        <div className="front-vehicle-badge">
            {icon}
            {value}
        </div>
    )
}

export default VehicleBadge